"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VipGradeRadioTextMap = exports.UserTypeTextMap = exports.SendSceneTextMap = exports.RecommendTypeTextMap = exports.RecommendTypeTagMap = exports.RecommendTypeMap = exports.PopupTypes = exports.IsVipTextMap = exports.IsSaleOrderTextMap = exports.IsNewPeopleCouponTextMap = exports.IsAddQyTextMap = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
// 弹窗类型枚举
var PopupTypes = exports.PopupTypes = {
  // 弹窗类型
  POP_TYPE: {
    MENU: 1,
    // 菜单页
    HOME: 2,
    // 首页
    COMMUNITY: 3 // 社区
  },
  // 推荐类型
  RECOMMEND_TYPE: {
    NOTHING: 1,
    // NOTHING
    COUPON: 2,
    // 领券弹窗
    ACTIVITY: 3,
    // 系统弹窗
    DIRECT: 4,
    // 直接跳转
    SURVEY: 5,
    // 调查问卷
    EXTERNAL: 6,
    // 外部小程序
    WECHAT: 7,
    // 微信红包封面
    SCREEN: 8 // 滑屏弹窗
  },
  // 发布场景
  SEND_SCENE: {
    TAKEOUT: 3,
    // 外卖
    DINING: 1,
    // 堂食
    PICKUP: 2 // 自提
  },
  // 是否会员
  IS_VIP: {
    ALL: 1,
    // 全部
    YES: 2,
    // 是
    NO: 3 // 否
  },
  // 是否添加企微
  IS_ADD_QY: {
    ALL: 1,
    // 全部
    YES: 2,
    // 是
    NO: 3 // 否
  },
  // 是否下单
  IS_SALE_ORDER: {
    ALL: 1,
    // 全部
    NOT_ORDERED: 2,
    // 未下过单
    ORDERED: 3 // 下过单
  },
  // 新人券是否过期
  IS_NEW_PEOPLE_COUPON: {
    ALL: 1,
    // 全部
    EXPIRED: 2,
    // 过期
    VALID: 3 // 未过期
  },
  // 会员级别单选
  VIP_GRADE_RADIO: {
    LV1_ABOVE: 1,
    // lv1及以上
    LV2_ABOVE: 2,
    // lv2及以上
    LV3_ABOVE: 3,
    // lv3及以上
    LV4: 4,
    // lv4
    LV5: 5 // lv5
  },
  // 用户类型
  USER_TYPE: {
    NORMAL: 1,
    // 普通
    NEW: 2,
    // 新用户
    OLD: 3 // 老用户
  }
};

// 推荐类型映射（用于标签页）
var RecommendTypeMap = exports.RecommendTypeMap = {
  0: '',
  1: PopupTypes.RECOMMEND_TYPE.NOTHING,
  2: PopupTypes.RECOMMEND_TYPE.COUPON,
  3: PopupTypes.RECOMMEND_TYPE.ACTIVITY,
  4: PopupTypes.RECOMMEND_TYPE.DIRECT,
  8: PopupTypes.RECOMMEND_TYPE.SCREEN,
  5: PopupTypes.RECOMMEND_TYPE.SURVEY,
  6: PopupTypes.RECOMMEND_TYPE.EXTERNAL,
  7: PopupTypes.RECOMMEND_TYPE.WECHAT
};

// 推荐类型文本映射
var RecommendTypeTextMap = exports.RecommendTypeTextMap = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, PopupTypes.RECOMMEND_TYPE.NOTHING, 'NOTHING'), PopupTypes.RECOMMEND_TYPE.COUPON, '领券弹窗'), PopupTypes.RECOMMEND_TYPE.ACTIVITY, '系统弹窗'), PopupTypes.RECOMMEND_TYPE.DIRECT, '直接跳转'), PopupTypes.RECOMMEND_TYPE.SCREEN, '滑屏弹窗'), PopupTypes.RECOMMEND_TYPE.SURVEY, '调查问卷'), PopupTypes.RECOMMEND_TYPE.EXTERNAL, '外部小程序'), PopupTypes.RECOMMEND_TYPE.WECHAT, '微信红包封面');

// 推荐类型标签样式映射
var RecommendTypeTagMap = exports.RecommendTypeTagMap = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, PopupTypes.RECOMMEND_TYPE.NOTHING, 'success'), PopupTypes.RECOMMEND_TYPE.COUPON, 'success'), PopupTypes.RECOMMEND_TYPE.ACTIVITY, 'success'), PopupTypes.RECOMMEND_TYPE.DIRECT, 'success'), PopupTypes.RECOMMEND_TYPE.SCREEN, 'success'), PopupTypes.RECOMMEND_TYPE.SURVEY, 'success'), PopupTypes.RECOMMEND_TYPE.EXTERNAL, 'success'), PopupTypes.RECOMMEND_TYPE.WECHAT, 'success');

// 发布场景文本映射
var SendSceneTextMap = exports.SendSceneTextMap = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, PopupTypes.SEND_SCENE.TAKEOUT, '外卖'), PopupTypes.SEND_SCENE.DINING, '堂食'), PopupTypes.SEND_SCENE.PICKUP, '自提');

// 是否会员文本映射
var IsVipTextMap = exports.IsVipTextMap = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, PopupTypes.IS_VIP.ALL, '全部'), PopupTypes.IS_VIP.YES, '是'), PopupTypes.IS_VIP.NO, '否');

// 是否添加企微文本映射
var IsAddQyTextMap = exports.IsAddQyTextMap = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, PopupTypes.IS_ADD_QY.ALL, '全部'), PopupTypes.IS_ADD_QY.YES, '是'), PopupTypes.IS_ADD_QY.NO, '否');

// 是否下单文本映射
var IsSaleOrderTextMap = exports.IsSaleOrderTextMap = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, PopupTypes.IS_SALE_ORDER.ALL, '全部'), PopupTypes.IS_SALE_ORDER.NOT_ORDERED, '未下过单'), PopupTypes.IS_SALE_ORDER.ORDERED, '下过单');

// 新人券是否过期文本映射
var IsNewPeopleCouponTextMap = exports.IsNewPeopleCouponTextMap = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, PopupTypes.IS_NEW_PEOPLE_COUPON.ALL, '全部'), PopupTypes.IS_NEW_PEOPLE_COUPON.EXPIRED, '过期'), PopupTypes.IS_NEW_PEOPLE_COUPON.VALID, '未过期');

// 会员级别单选文本映射
var VipGradeRadioTextMap = exports.VipGradeRadioTextMap = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, PopupTypes.VIP_GRADE_RADIO.LV1_ABOVE, 'lv1及以上'), PopupTypes.VIP_GRADE_RADIO.LV2_ABOVE, 'lv2及以上'), PopupTypes.VIP_GRADE_RADIO.LV3_ABOVE, 'lv3及以上'), PopupTypes.VIP_GRADE_RADIO.LV4, 'lv4'), PopupTypes.VIP_GRADE_RADIO.LV5, 'lv5');

// 用户类型文本映射
var UserTypeTextMap = exports.UserTypeTextMap = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, PopupTypes.USER_TYPE.NORMAL, '普通'), PopupTypes.USER_TYPE.NEW, '新用户'), PopupTypes.USER_TYPE.OLD, '老用户');